module.exports = __webpack_public_path__ + "static/media/Aeros App.d41d8cd9.title";